export const tipoFornecedor = [
  'Serviços',
  'Materiais',
];

export const tamanhoEmpresa = [
  'P',
  'M',
  'G',
];

export const tipoContrato = [
  'Simplificado',
  'Completo',
];

export const tipoAnalise = [
  'Com análise qualitativa',
  'Sem análise qualitativa',
];

export const dfAuditada = [
  'Sim',
  'Não',
];

// SEMPRE TEM QUE ESTAR SINCRONIZADO COM O SERVICES/PARTNER/VOLTZ NO PARSE-SERVER
export const variables = {
  'Serviços:P:Simplificado:Com análise qualitativa': [
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
  ],
  'Serviços:P:Simplificado:Sem análise qualitativa': [
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
  ],
  'Serviços:P:Completo:Com análise qualitativa': [
    { label: 'Controladoria', value: 'controladoria' },
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
  ],
  'Serviços:P:Completo:Sem análise qualitativa': [
    { label: 'Controladoria', value: 'controladoria' },
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
  ],
  'Serviços:M:Simplificado:Com análise qualitativa': [
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
  ],
  'Serviços:M:Simplificado:Sem análise qualitativa': [
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
  ],
  'Serviços:M:Completo:Com análise qualitativa': [
    { label: 'Controladoria', value: 'controladoria' },
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
  ],
  'Serviços:M:Completo:Sem análise qualitativa': [
    { label: 'Controladoria', value: 'controladoria' },
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
  ],
  'Serviços:G:Simplificado:Com análise qualitativa': [
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Ind. Finan.', value: 'indicadoresFinanceiros' },
  ],
  'Serviços:G:Simplificado:Sem análise qualitativa': [
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Ind. Finan.', value: 'indicadoresFinanceiros' },
  ],
  'Serviços:G:Completo:Com análise qualitativa': [
    { label: 'Controladoria', value: 'controladoria' },
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Ind. Finan.', value: 'indicadoresFinanceiros' },
  ],
  'Serviços:G:Completo:Sem análise qualitativa': [
    { label: 'Controladoria', value: 'controladoria' },
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Ind. Finan.', value: 'indicadoresFinanceiros' },
  ],
  'Materiais:P::Com análise qualitativa': [
    { label: 'BI materiais', value: 'biMateriais' },
    { label: 'OTIF', value: 'otif' },
  ],
  'Materiais:P::Sem análise qualitativa': [
    { label: 'BI materiais', value: 'biMateriais' },
    { label: 'OTIF', value: 'otif' },
  ],
  'Materiais:M::Com análise qualitativa': [
    { label: 'BI materiais', value: 'biMateriais' },
    { label: 'OTIF', value: 'otif' },
  ],
  'Materiais:M::Sem análise qualitativa': [
    { label: 'BI materiais', value: 'biMateriais' },
    { label: 'OTIF', value: 'otif' },
  ],
  'Materiais:G::Com análise qualitativa': [
    { label: 'BI materiais', value: 'biMateriais' },
    { label: 'OTIF', value: 'otif' },
    { label: 'Ind. Finan.', value: 'indicadoresFinanceiros' },
  ],
  'Materiais:G::Sem análise qualitativa': [
    { label: 'BI materiais', value: 'biMateriais' },
    { label: 'OTIF', value: 'otif' },
    { label: 'Ind. Finan.', value: 'indicadoresFinanceiros' },
  ],
};

export const variableOptions = {
  Serviços: {
    controladoria: {
      100: 'Conforme (fornecedor não possui bloqueio)',
      30: {
        tamanhoEmpresa: {
          P: 'Parcialmente conforme (fornecedor possui bloqueio por renovação de seguros)',
          M: 'Parcialmente conforme (fornecedor possui bloqueio por renovação de seguros)',
          G: 'Parcialmente conforme (fornecedor possui bloqueio por renovação de seguros ex-garantia)',
        },
      },
      0: {
        tamanhoEmpresa: {
          P: 'Não conforme (fornecedor possui bloqueio por não envio de comprovantes)',
          M: 'Não conforme (fornecedor possui bloqueio por não envio de comprovantes)',
          G: 'Não conforme (fornecedor possui bloqueio por não envio de comprovantes OU pendência seguro garantia)',
        },
      },
    },
    juridico: {
      100: 'Conforme (fornecedor não possui nenhum processo)',
      30: {
        tamanhoEmpresa: {
          P: 'Parcialmente conforme (fornecedor possui processos com perda provável até 50% do faturamento médio mensal)',
          M: 'Parcialmente conforme (fornecedor possui processos com perda provável até 50% do faturamento médio mensal)',
          G: 'Parcialmente conforme (fornecedor possui processos com perda provável até 100% do faturamento médio mensal)',
        },
      },
      0: {
        tamanhoEmpresa: {
          P: 'Não conforme (fornecedor possui processos com perda provável acima de 50% do faturamento médio mensal)',
          M: 'Não conforme (fornecedor possui processos com perda provável acima de 50% do faturamento médio mensal)',
          G: 'Não conforme (fornecedor possui processos com perda provável acima de 100% do faturamento médio mensal)',
        },
      },
    },
    gestor: {
      100: 'Conforme (fornecedor prestando serviço normalmente)',
      30: 'Parcialmente conforme (fornecedor está prestando serviço mas houve queda/perspectiva redução ou alto turnover)',
      0: 'Não conforme (fornecedor não está pagando fornecedores regionais / muitas ocorrências / risco de rescisão)',
    },
    analiseRisco: {
      100: 'Conforme (Baixo risco)',
      30: 'Parcialmente conforme (Médio risco)',
      0: 'Não conforme (Alto risco)',
    },
    indicadoresFinanceiros: {
      100: 'Conforme (LC >= 1,5x E FCO > 0 E LL > 0)',
      30: 'Parcialmente conforme (LC >= 1,0x E FCO > 0 OU LL < 0)',
      0: 'Não conforme (LC < 1,0x E FCO < 0 E LL < 0)',
    },
  },
  Materiais: {
    biMateriais: {
      100: 'Conforme (consumo regular ou acelerado)',
      30: 'Parcialmente conforme (consumo baixo mas com mais de 50% de prazo)',
      0: 'Não conforme (consumo baixo e menos de 50% de prazo restante)',
    },
    otif: {
      100: 'Conforme (Acima de 70%)',
      30: 'Parcialmente conforme (50,01% a 70%)',
      0: 'Não conforme (0% a 50%)',
    },
    analiseRisco: {
      100: 'Conforme (Baixo risco)',
      30: 'Parcialmente conforme (Médio risco)',
      0: 'Não conforme (Alto risco)',
    },
    indicadoresFinanceiros: {
      100: 'Conforme (LC >= 1,5x E FCO > 0 E LL > 0)',
      30: 'Parcialmente conforme (LC >= 1,0x E FCO > 0 OU LL < 0)',
      0: 'Não conforme (LC < 1,0x E FCO < 0 E LL < 0)',
    },
  },
};
